export default __webpack_public_path__ + "static/media/usermanualdashboard.f417bb00.svg";